@if(selectedProjectId() !== null){
@if (wizardInitializing()) {
<div
  class="d-flex flex-column align-items-center justify-content-center py-5 my-5"
>
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">{{ "general.loading" | translate }}</span>
  </div>
  <p class="text-body-secondary mt-3 mb-0">
    {{ "general.loading" | translate }}
  </p>
</div>
} @else {
<app-details-page-header
  [title]="'admin.projectIdeas.actions.edit' | translate"
  [subtitle]="headerProjectName()"
  [id]="selectedProjectId() || ''"
  (back)="goBack()"
>
  <button
    class="btn btn-falcon-default btn-sm"
    type="button"
    [disabled]="savingAdmin() || loadingAdminStep() || submittingState()"
    (click)="onSaveAdminDraft()"
  >
    <span class="fas fa-save me-2" data-fa-transform="shrink-3"></span
    >{{ "projectWizard.saveDraft" | translate }}
  </button>
  @if (showAdminApproveDecline()) {
  <button
    class="btn btn-outline-secondary btn-sm"
    type="button"
    [disabled]="submittingState() || savingAdmin() || loadingAdminStep()"
    (click)="onAdminApprove()"
  >
    {{ "projectWizard.adminState.approve" | translate }}
  </button>
  <button
    class="btn btn-outline-danger btn-sm"
    type="button"
    [disabled]="submittingState() || savingAdmin() || loadingAdminStep()"
    (click)="onAdminDecline()"
  >
    {{ "projectWizard.adminState.decline" | translate }}
  </button>
  }
  @if (adminNextPrimaryLabelKey(); as nextKey) {
  <button
    class="btn btn-primary btn-sm"
    type="button"
    [disabled]="submittingState() || savingAdmin() || loadingAdminStep()"
    (click)="onAdminNextPrimary()"
  >
    <span class="fab fa-telegram-plane btn-icon" data-fa-transform="grow-5">
    </span>
    {{ nextKey | translate }}
  </button>
  }
</app-details-page-header>
<app-wizard
  [prevButtonEnabled]="!savingAdmin()"
  [nextButtonEnabled]="!savingAdmin()"
  [prevButtonText]="prevButtonText()"
  [nextButtonText]="nextButtonText()"
  [prevButtonHasChevron]="prevButtonHasChevron()"
  [nextButtonHasChevron]="nextButtonHasChevron()"
  [items]="wizardItems()"
  (stepSelection)="onStepSelection($event)"
  (nextButtonClicked)="onNextButtonClick()"
  (prevButtonClicked)="onPreviousButtonClick()"
>
  @if (isAdminStepActive()) {
  <app-wizard-step
    stepId="form-wizard-progress-tab-admin"
    [stepNumber]="0"
    [isActive]="isAdminStepActive()"
  >
    <app-project-admin-idea-step
      [form]="adminForm"
      [project]="project()"
      [loading]="loadingAdminStep()"
    />
  </app-wizard-step>
  } @else { @switch (stepsStore.stepIndex()) { @case (0) {
  <app-wizard-step
    stepId="form-wizard-progress-tab0"
    [stepNumber]="0"
    [isActive]="stepsStore.stepIndex() == 0"
  >
    <app-base-data-step [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (1) {
  <app-wizard-step
    stepId="form-wizard-progress-tab1"
    [stepNumber]="1"
    [isActive]="stepsStore.stepIndex() == 1"
  >
    <app-section-a [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (2) {
  <app-wizard-step
    stepId="form-wizard-progress-tab2"
    [stepNumber]="2"
    [isActive]="stepsStore.stepIndex() == 2"
  >
    <app-section-b [projectId]="selectedProjectId()!" />
  </app-wizard-step>

  } @case (3) {
  <app-wizard-step
    stepId="form-wizard-progress-tab3"
    [stepNumber]="3"
    [isActive]="stepsStore.stepIndex() == 3"
  >
    <app-section-c [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (4) {
  <app-wizard-step
    stepId="form-wizard-progress-tab4"
    [stepNumber]="4"
    [isActive]="stepsStore.stepIndex() == 4"
  >
    <app-section-d
      [projectId]="selectedProjectId()!"
      [stepDisabled]="stepsStore.actualSteps()[4]?.stepType === StepType.disabled"
    />
  </app-wizard-step>
  } @case (5) {

  <app-wizard-step
    stepId="form-wizard-progress-tab5"
    [stepNumber]="5"
    [isActive]="stepsStore.stepIndex() == 5"
  >
    <app-section-e
      [projectId]="selectedProjectId()!"
      [stepDisabled]="stepsStore.actualSteps()[5]?.stepType === StepType.disabled"
    />
  </app-wizard-step>
  } @case (6) {
  <app-wizard-step
    stepId="form-wizard-progress-tab6"
    [stepNumber]="6"
    [isActive]="stepsStore.stepIndex() == 6"
  >
    <app-section-f [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (7) {
  <app-wizard-step
    stepId="form-wizard-progress-tab7"
    [stepNumber]="7"
    [isActive]="stepsStore.stepIndex() == 7"
  >
    <app-section-g [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (8) {
  <app-wizard-step
    stepId="form-wizard-progress-tab8"
    [stepNumber]="8"
    [isActive]="stepsStore.stepIndex() == 8"
  >
    <app-section-h [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (9) {
  <app-wizard-step
    stepId="form-wizard-progress-tab9"
    [stepNumber]="9"
    [isActive]="stepsStore.stepIndex() == 9"
  >
    <app-section-i [projectId]="selectedProjectId()!" />
  </app-wizard-step>
  } @case (10) {
  <app-wizard-step
    stepId="form-wizard-progress-tab10"
    [stepNumber]="10"
    [isActive]="stepsStore.stepIndex() == 10"
  >
    <app-section-j [projectId]="selectedProjectId()!" />
  </app-wizard-step>

  } }
  }
</app-wizard>
}
}
